import { render, staticRenderFns } from "./SearchSuggestItem.vue?vue&type=template&id=04cc643c"
import script from "./SearchSuggestItem.vue?vue&type=script&lang=js"
export * from "./SearchSuggestItem.vue?vue&type=script&lang=js"
import style0 from "./SearchSuggestItem.vue?vue&type=style&index=0&id=04cc643c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports